module.exports = __webpack_public_path__ + "static/media/25UNHCR2.15d5d045.jpg";